import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import {
  Typography,
  Button,
  TableContainer,
  Table,
  TableBody,
  Container,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import { StyledTableCell, StyledTableRow } from "../modules/modules";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { makeStyles } from "@material-ui/core/styles";
import { API } from "aws-amplify";
import * as mutations from "../graphql/mutations";
// import * as queries from "../graphql/queries";

// クリップボード
import CopyToClipBoard from "react-copy-to-clipboard";

const api_name = process.env.REACT_APP_API_NAME;
if (process.env.NODE_ENV === "development") {
  var base_url = "http://localhost:3000";
} else if (process.env.NODE_ENV === "production") {
  base_url = "https://new.pluselect.com";
}

const useStyles = makeStyles((theme) => ({
  interval: {
    marginTop: theme.spacing(5),
  },
  button: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
}));

export default function ConnectAccount(props) {
  const classes = useStyles();
  const userInfo = props.userInfo;
  const { accountID } = useParams();
  const [link, setLink] = useState();
  const [stripeAccount, setStripeAccount] = useState();
  const [loginLink, setLoginLink] = useState();

  const [tooltip, setTooltip] = useState(false);
  const [creating, setCreating] = useState(false);

  useEffect(() => {
    // userInfoにstripeAccountがある場合
    if (userInfo.stripeAccount) {
      setStripeAccount(userInfo.stripeAccount);
    }
  }, [userInfo]);

  useEffect(() => {
    if (stripeAccount) {
      createLoginLink(stripeAccount);
      handleCreateRefreshLink(stripeAccount);
      // Adminしか認証されていない
      // listUserInfosBySpecificStripeParentAccount(stripeAccount)
    }
  }, [stripeAccount]);

  // ログインリンクを作成
  const createLoginLink = (accountID) => {
    var query = {
      body: {
        accountID: accountID,
      },
    };
    if (!loginLink) {
      API.post(api_name, "/stripe/createLoginLink", query)
        .then((res) => {
          console.log(res);
          setLoginLink(res.url);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  // リフレッシュリンクを作成
  const handleCreateRefreshLink = (accountID) => {
    var query = {
      body: {
        accountID: accountID,
        return_url: `${base_url}/#/connect/${accountID}`,
      },
    };
    if (!link) {
      API.post(api_name, "/stripe/createAccountLink/refresh", query)
        .then((res) => {
          console.log(res);
          setLink(res.url);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleCreateLink = () => {
    setCreating(true);
    // 最初のアクセスの場合
    var query = {
      body: {
        return_url: `${base_url}/#/connect/${accountID}`,
      },
    };
    if (!link) {
      API.post(api_name, "/stripe/createAccountLink", query)
        .then((res) => {
          console.log(res);
          setLink(res.url);
          updateAccountId(res.accountID);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  // アカウントリンクの作成
  const updateAccountId = (accountID) => {
    var input = {
      id: userInfo.id,
      stripeAccount: accountID,
    };
    API.graphql({
      query: mutations.updateUserInfo,
      variables: { input: input },
    })
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <React.Fragment>
      <Container className={classes.interval}>
        <Typography variant="h4" align="center" gutterBottom>
          アフィリエイトアカウント
        </Typography>
        {accountID !== "create" ||
        userInfo.stripeAccount ||
        link ||
        loginLink ? null : (
          <Button
            className={classes.button}
            variant="contained"
            disabled={creating}
            onClick={() => handleCreateLink()}
          >
            アカウントを作成する
          </Button>
        )}

        {!link || loginLink ? null : (
          <Button
            className={classes.button}
            variant="contained"
            target="_blank"
            color="primary"
            href={link}
          >
            初期設定
          </Button>
        )}

        {!loginLink ? null : (
          <Button
            className={classes.button}
            variant="contained"
            target="_blank"
            color="primary"
            href={loginLink}
          >
            ログイン
          </Button>
        )}
      </Container>

      {stripeAccount ? (
        <Container className={classes.interval}>
          <Typography variant="h4" align="center" gutterBottom>
            以下のリンクをコピーして紹介してください ↓
          </Typography>
          <TableContainer className={classes.table}>
            <Table stickyHeader>
              <TableBody>
                <StyledTableRow>
                  <StyledTableCell variant="head">紹介リンク</StyledTableCell>
                  <StyledTableCell>
                    {`${base_url}?stripeParentAccount=${stripeAccount}`}
                    <Tooltip
                      arrow
                      open={tooltip}
                      onClose={() => setTooltip(false)}
                      disableHoverListener
                      placement="right"
                      title="コピーしました!"
                    >
                      <CopyToClipBoard
                        text={`${base_url}?stripeParentAccount=${stripeAccount}`}
                      >
                        <IconButton
                          size="small"
                          onClick={() => setTooltip(true)}
                        >
                          <FileCopyIcon />
                        </IconButton>
                      </CopyToClipBoard>
                    </Tooltip>
                  </StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell variant="head">紹介LPリンク</StyledTableCell>
                  <StyledTableCell>
                    {`https://www.pluselect.com/affiliate-lp?stripeParentAccount=${stripeAccount}`}
                    <Tooltip
                      arrow
                      open={tooltip}
                      onClose={() => setTooltip(false)}
                      disableHoverListener
                      placement="right"
                      title="コピーしました!"
                    >
                      <CopyToClipBoard
                        text={`https://www.pluselect.com/affiliate-lp?stripeParentAccount=${stripeAccount}`}
                      >
                        <IconButton
                          size="small"
                          onClick={() => setTooltip(true)}
                        >
                          <FileCopyIcon />
                        </IconButton>
                      </CopyToClipBoard>
                    </Tooltip>
                  </StyledTableCell>
                </StyledTableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Container>
      ) : null}

      <Container className={classes.interval}>
        <Typography variant="h4" align="center" gutterBottom>
          マニュアル
        </Typography>
        <iframe
          title="Manual"
          src="https://www.pluselect.com/affiliate"
          width="100%"
          height="800"
        />
      </Container>
    </React.Fragment>
  );
}
